module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec06_eca5b50aaf5595be0be6081a89ba24ef.jpg";